import Vue from 'vue';
import App from './App.vue';
import Footer from './components/Footer.vue';
import Body from './components/Body.vue';
import vueHeadful from 'vue-headful';
import 'alpinejs';
Vue.config.productionTip = false
Vue.component('vue-headful', vueHeadful);
Vue.component('footer-content', Footer);
Vue.component('body-content', Body);

new Vue({
  render: h => h(App),
}).$mount('#app')
